<div class="work-card no-padding margin-bottom-16">
  <div class="inline-padding">
    <h3>{{ 'STUNDEN_SALDO' | translate }}</h3>
  </div>
  <ul class="work-list">
    <li>
      <p><small class="work-text-color-light">{{ 'STUNDEN_AKTUELLER_SALDO' | translate }}</small></p>
      <p [ngClass]="saldoIsPositive() ? 'saldo-positive' : 'saldo-negative'">
        <strong>{{ balance().saldo | number:'1.1-1' }} h</strong>
      </p>
    </li>
  </ul>
</div>
